'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { EXIT_INTENT_SIGNAL } from '../constants';
import { type ExitIntentTrigger, hasExitIntentBeenShown } from '../utils/session';
export function useVisibilityReturnSignal(triggerRef, hasFired) {
  const $ = _c(4);
  const wasHiddenRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== hasFired || $[1] !== triggerRef) {
    t0 = () => {
      if (hasFired || hasExitIntentBeenShown()) {
        return;
      }
      const onVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          wasHiddenRef.current = true;
          return;
        }
        if (wasHiddenRef.current) {
          triggerRef.current?.(EXIT_INTENT_SIGNAL.visibilityReturn);
        }
      };
      document.addEventListener("visibilitychange", onVisibilityChange);
      return () => document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    t1 = [triggerRef, hasFired];
    $[0] = hasFired;
    $[1] = triggerRef;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}